import * as React from "react"; // tslint:disable-line
import styled from "styled-components";

type EllipsisProps = {
  line: number;
};

/* stylelint-disable value-no-vendor-prefix */
/* stylelint-disable property-no-vendor-prefix */
const Ellipsis = styled.p<EllipsisProps>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.line};
  overflow: hidden;
  overflow-wrap: break-word;
`;

export { Ellipsis, EllipsisProps };
